import { render, staticRenderFns } from "./factor_m.vue?vue&type=template&id=76a10842"
import script from "./factor_m.vue?vue&type=script&lang=js"
export * from "./factor_m.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports